export const RANGE_ERROR_MESSAGES = {
  tooLong: 'requestVideo_rangeError_tooLong',
  outside: 'requestVideo_rangeError_outside',
  missing: 'requestVideo_rangeError_missing',
};

export const REQUEST_ERROR_MESSAGES = {
  alreadyRequested: 'requestVideo_error_alreadyRequested',
  cameraNotFound: 'requestVideo_error_cameraNotFound',
  rangeNotAvailable: 'requestVideo_error_rangeNotAvailable',
  generic: 'requestVideo_error_generic',
};

export const LEGEND_MESSAGES = {
  driving: 'requestVideo_legend_driving',
  idling: 'requestVideo_legend_idling',
  stopped: 'requestVideo_legend_stopped',
};

